/**
 * @generated SignedSource<<65be056b53eb53dfd06bcb2f99cf7ca4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type iabCategoryAppConfigQuery$variables = Record<PropertyKey, never>;
export type iabCategoryAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type iabCategoryAppConfigQuery = {
  response: iabCategoryAppConfigQuery$data;
  variables: iabCategoryAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "scmp_iab_category"
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "iabCategoryAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_iab_category\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "iabCategoryAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_iab_category\"})"
      }
    ]
  },
  "params": {
    "cacheID": "3ef1bdb470ad40b4e01c73451ae2e01b",
    "id": null,
    "metadata": {},
    "name": "iabCategoryAppConfigQuery",
    "operationKind": "query",
    "text": "query iabCategoryAppConfigQuery {\n  appConfig(filter: {entityId: \"scmp_iab_category\"}) {\n    json\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d2f08894204be20667bf2145d863b2c";

export default node;
